export default "__VITE_ASSET__BVqUX2Mt__"